import { Filters } from '@features/properties/components/properties-filters/filters';

import { FilterState } from '../store';

export const transformPayload = (items: Filters): FilterState => {
    const constructedFilters: FilterState = {};

    Object.keys(items).forEach((key) => {
        const filterName = key as keyof typeof items;
        const { hasRangeValues, filterFunctions, filterLogic, filters } = items[filterName];

        constructedFilters[filterName] = {
            hasRangeValues,
            filterFunctions,
            filterLogic,
            inputs: filters.components.map(({ label, id, name, checked, value, type }) => ({
                label,
                id,
                name,
                checked,
                value,
                type,
            })),
        };
    });
    return constructedFilters;
};
